// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"f6dd2e90","453":"38826d00","455":"818e3288","977":"6e736b7d"}[chunkId] + ".chunk.js";
};